<template>
  <div class="testBox">
    <div class="testInnerBox">
      <div class="close" @click="closeTestBox">
        <img src="../assets/close.png" />
      </div>
      <div class="title">为了保证您正常上课，请先进行以下检测。</div>
      <div class="testCenter">
        <div class="centerItem" v-for="item in testBoxContent" :key="item.id">
          <img :src="item.url" />
        </div>
        <img :src="rightImg" class="right1 right" />
        <img :src="rightImg" class="right2 right" />
      </div>
      <div class="testBox2">
        <div v-for="item in testBoxContent" :key="item.id">
          <span>{{item.text}}</span>
        </div>
      </div>
      <div class="testBtn">
        <button @click="beginTest">开始检测</button>
      </div>
    </div>
    <TestInner v-show="testInnerFlag" @closeTestInner="closeTestInner" />
  </div>
</template>

<script>
import TestInner from "./test_inner";
export default {
  components: {
    TestInner
  },
  data() {
    return {
      testBoxContent: [
        {
          id: 1,
          url: require("../assets/img/one.png"),
          text: "基本检测"
        },
        {
          id: 2,
          url: require("../assets/img/two.png"),
          text: "耳机/扬声器"
        },
        {
          id: 3,
          url: require("../assets/img/thr.png"),
          text: "麦克风"
        }
      ],
      rightImg: require("../assets/img/right.png"),
      testInnerFlag: false
    };
  },
  methods: {
    closeTestBox() {
      this.$emit("closeTestBox", false);
    },
    beginTest() {
      this.testInnerFlag = true;
    },
    closeTestInner(arg) {
      this.testInnerFlag = arg;
      this.$emit('closeTestBox', false);
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin wh($w: 100%, $h: 100%) {
  width: $w;
  height: $h;
}
@mixin flexCenter() {
  display: flex;
  align-items: center;
  justify-content: center;
}
@mixin flexColumn() {
  display: flex;
  flex-direction: column;
}
@mixin marginAuto() {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.testBox {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(#000000, 0.75);
  z-index: 88;
  .testInnerBox {
    @include wh(791px, 527px);
    @include marginAuto();
    border-radius: 30px;
    background-color: #fff;
    padding: 15px 25px;
    box-sizing: border-box;
    background-image: url("../assets/bottom.png");
    background-position: left bottom;
    background-size: cover;
    .close {
      @include wh(62px, 62px);
      right: -25px;
      top: -25px;
      &:hover {
        transform: scale(1.2);
      }
    }
    .title {
      color: #ff8f00;
      font-size: 24px;
      margin-top: 25px;
      text-align: center;
    }
    .testCenter {
      @include wh(100%, 200px);
      display: flex;
      align-items: center;
      padding: 0 30px;
      margin-top: 20px;
      box-sizing: border-box;
      justify-content: space-evenly;
      position: relative;
      .centerItem {
        @include wh(145px, 145px);
        @include flexCenter();
        background: rgba(255, 250, 225, 1);
        border: 2px solid rgba(255, 203, 68, 1);
        border-radius: 50%;
        flex-direction: column;
        margin: 0 30px;
        &:nth-child(3) img {
          width: 45px;
        }
        img {
          @include wh(60px, 60px);
        }
      }
      .right {
        @include wh(30px, 30px);
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      .right1 {
        left: 252px;
      }
      .right2 {
        left: 468px;
      }
    }
  }
  .testBox2 {
    width: 100%;
    height: 40px;
    display: flex;
    box-sizing: border-box;
    padding: 0 30px;
    justify-content: space-evenly;
    div {
      width: 149px;
      margin: 0 30px;
      text-align: center;
      span {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(72, 72, 72, 1);
      }
    }
  }
  .testBtn {
    @include wh(100%, 60px);
    @include flexCenter();
    margin-top: 30px;
    button {
      @include wh(158px, 53px);
      background: rgba(255, 143, 0, 1);
      border-radius: 26px;
      border: 0;
      outline: none;
      font-size: 21px;
      color: #fff;
      cursor: pointer;
      transition: all 0.5s ease;
      &:hover {
        background: rgb(240, 117, 69);
        color: #eee;
      }
    }
  }
}
.close {
  @include wh(94px, 94px);
  position: absolute;
  top: -47px;
  right: -50px;
  cursor: pointer;
  transition: all 0.5s ease;
  &:hover {
    transform: rotate(180deg);
  }
  img {
    @include wh();
  }
}
</style>